import { Button, Space, Typography } from 'antd';

import { StyledModal } from 'common/components';

const { Paragraph, Text } = Typography;

const PROFESSIONAL_CAPTURE_SERVICES_URL =
  'https://www.thedatacouncil.com/productloadform/';

const AddProductWarningModal = ({
  visible,
  onAcknowledge,
  onCapture,
  onCancel,
}) => {
  return (
    <StyledModal
      visible={visible}
      title={null}
      width={520}
      closable={false}
      maskClosable
      onCancel={onCancel}
      footer={[
        <Space key='add-product-warning-footer'>
          <Button onClick={onCancel}>Cancel</Button>
          <Button onClick={onCapture}>Capture</Button>
          <Button type='primary' onClick={onAcknowledge}>
            Acknowledge
          </Button>
        </Space>,
      ]}
    >
      <Paragraph style={{ fontSize: 15, marginBottom: 0 }}>
        Some of our partners such as{' '}
        <Text style={{ fontWeight: 500 }}>
          Whole Foods, KeHE, Fresh Thyme, and Sprouts
        </Text>{' '}
        require the data and images to be IX-ONE certified through our{' '}
        <a
          href={PROFESSIONAL_CAPTURE_SERVICES_URL}
          target='_blank'
          rel='noreferrer'
          style={{ textDecoration: 'underline' }}
        >
          Professional Capture Services
        </a>
        . Self-loaded items cannot be seen publicly on the platform. Click{' '}
        <Text style={{ fontWeight: 'bold' }}>Acknowledge</Text> to continue or{' '}
        <Text style={{ fontWeight: 'bold' }}>Capture</Text> to be{' '}
        <span style={{ whiteSpace: 'nowrap' }}>re-routed</span> to IX-ONE
        Capture menu.
      </Paragraph>
    </StyledModal>
  );
};

export default AddProductWarningModal;
